export enum EnvironmentEnum {
  LOCAL_DEVELOPMENT = "local-development",
  DEVELOPMENT = "development",
  STAGING = "staging",
  UAT = "uat",
  PRODUCTION = "production",
}
